module.exports = __webpack_public_path__ + "static/media/Gotham-Book.d74d9422.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Book.woff
 ** module id = 1337
 ** module chunks = 0
 **/